module.exports = __webpack_public_path__ + "static/media/ic_refresh_gray.6750d5a1.svg";